import isDate from 'lodash-es/isDate'
import { ulid } from 'ulid'

export function getRandomId() {
	return ulid()
}

export function sortArray<T>(
	array: T[] | undefined,
	selector: (value: T) => string | number | Date = (x: any) => x,
	reverseOrder = false
): T[] {
	if (!array) {
		return []
	}
	array.sort((a, b) => {
		const valueA = selector(a)
		const valueB = selector(b)
		if (typeof valueA === 'string' && typeof valueB === 'string') {
			return valueA.localeCompare(valueB)
		} else if (typeof valueA === 'number' && typeof valueB === 'number') {
			return valueA - valueB
		} else if (isDate(valueA) && isDate(valueB)) {
			return (valueA as Date).getTime() - (valueB as Date).getTime()
		}
		throw new Error('Invalid comparison')
	})
	if (reverseOrder) {
		array.reverse()
	}
	return array
}

export async function sleep(ms: number) {
	return new Promise(resolve => setTimeout(resolve, ms))
}
